import { render } from "./FilterButtons.vue?vue&type=template&id=5e716cfc&scoped=true"
import script from "./FilterButtons.vue?vue&type=script&lang=js"
export * from "./FilterButtons.vue?vue&type=script&lang=js"

import "./FilterButtons.vue?vue&type=style&index=0&id=5e716cfc&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e716cfc"]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QChip,QItem,QItemSection});
